import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { usePromo } from "./PromoBanner";

/** Large-format festive sale announcement shown on the home page while the sale is live. */
export const FestiveSale = () => {
  const promo = usePromo();
  if (!promo?.active) return null;

  const isBogo = promo.type === "bogo";

  return (
    <section
      data-testid="festive-sale-section"
      className="relative overflow-hidden border-b border-[#D4AF37]/40 bg-[#120E0B]"
    >
      <div className="absolute inset-0 pointer-events-none opacity-[0.07] bg-[radial-gradient(circle_at_20%_30%,#D4AF37,transparent_45%),radial-gradient(circle_at_80%_70%,#D4AF37,transparent_40%)]" />
      <div className="relative max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24 grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
        <div className="md:col-span-8">
          <p
            data-testid="festive-sale-label"
            className="text-[11px] md:text-xs tracking-overline uppercase font-bold text-[#D4AF37] mb-5"
          >
            ✦ {promo.label} · Now live ✦
          </p>
          <h2
            data-testid="festive-sale-headline"
            className="font-serif-display font-light text-5xl sm:text-7xl md:text-8xl lg:text-[132px] leading-[0.88] tracking-[-0.04em] text-[#F4EAD9]"
          >
            {isBogo ? (
              <>
                Buy <span className="italic text-[#D4AF37]">one</span>,
                <br />
                get <span className="italic text-[#D4AF37]">one</span> free.
              </>
            ) : (
              <>
                Flat <span className="italic text-[#D4AF37]">{promo.discount_pct}%</span> off
                <br />
                everything.
              </>
            )}
          </h2>
        </div>
        <div className="md:col-span-4 md:pb-3">
          <p className="text-base md:text-lg leading-relaxed text-[#B0A496]">
            {isBogo
              ? "On every perfume in the catalog. Add any flacon to your cart and a second one of the same ships free — no code needed."
              : "Applied automatically at checkout. No code needed."}
          </p>
          <p className="mt-3 text-[11px] tracking-overline uppercase font-bold text-[#D4AF37]">
            Free shipping PAN India
          </p>
          <Link
            data-testid="festive-sale-cta"
            to="/shop"
            className="mt-8 inline-flex items-center gap-3 bg-[#D4AF37] hover:bg-[#B8941F] text-[#15110F] px-8 py-4 text-[11px] tracking-overline uppercase font-bold transition-colors"
          >
            Shop the sale
            <ArrowUpRight size={16} strokeWidth={1.2} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default FestiveSale;
